import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SettingsProvider } from "./lib/SettingsContext";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";

function App() {
  useEffect(() => {
    const splash = document.getElementById("app-splash");
    if (splash) {
      setTimeout(() => splash.classList.add("hidden"), 400);
      setTimeout(() => splash.remove(), 1000);
    }
  }, []);

  return (
    <div className="App">
      <SettingsProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </SettingsProvider>
    </div>
  );
}

export default App;
